var benchmarkData = {
	"city4star": {
		"sessions": 27197,
		"conversion": 2.48
	},
	"country4star": {
		"sessions": 17533,
		"conversion": 0.99
	},
	"city5star": {
		"sessions": 13050,
		"conversion": 1.12
	},
	"country5star": {
		"sessions": 20911,
		"conversion": 0.57
	}
};

$(document).ready( function () {
	
	
	// Only show the view snapshot button once both proerty location and star rating have been selected
	$('input[type="radio"]').on('change', function() {
		if ( (typeof $('input[name="location"]:checked').val() != 'undefined') && (typeof $('input[name="rating"]:checked').val() != 'undefined') ) {
			$('#view-report').removeClass('hidden');
		}
	});
	
	
	$('.benchmark-form').on('submit', function() {
		
		var selectedLocation = $('input[name="location"]:checked').val();
		var selectedRating   = $('input[name="rating"]:checked').val()  ;
				
		$('#report-property-type').text( selectedLocation + ' ' + selectedRating );
		
		var avgConversion = benchmarkData[selectedLocation + selectedRating.replace(' ', '')].conversion;
		$('#report-avg-conversion').text( avgConversion  + '%' );
		
		var avgSessions = benchmarkData[selectedLocation + selectedRating.replace(' ', '')].sessions;
		$('#report-avg-sessions').text( numberWithCommas(avgSessions) );
		
		if ( ($('#website-sessions').val() != '') && ($('#website-bookings').val() != '') ) {
			var usersConversionRate = parseInt($('#website-bookings').val(), 10) / parseInt($('#website-sessions').val(), 10) * 100;
			usersConversionRate = parseFloat(usersConversionRate.toFixed(2)); // round to 2 decimal places but strip leading zeros
			$('#report-your-conversion').text( usersConversionRate + '%' );
			
			var usersSesssions = parseInt($('#website-sessions').val(), 10);
			$('#report-your-sessions').text( numberWithCommas(usersSesssions) );
			
			// Set the traffic light colour for the user's conversion rate
			$('#report-your-conversion').removeClass('green red');
			if ( usersConversionRate > avgConversion ) {
				$('#report-your-conversion').addClass('green');
			} else if ( usersConversionRate < avgConversion ) {
				$('#report-your-conversion').addClass('red');
			}
			
			// Set the traffic light colour for the user's sessions
			$('#report-your-sessions').removeClass('green red');
			if ( usersSesssions > avgSessions ) {
				$('#report-your-sessions').addClass('green');
			} else if ( usersSesssions < avgSessions ) {
				$('#report-your-sessions').addClass('red');
			}
			
			$('#report').addClass('show-optional');
		} else {
			$('#report').removeClass('show-optional');
			$('#report-your-conversion, #report-your-sessions').text( '' );
		}
		
		$('#report').slideDown();
		
		setTimeout(function () {
			$('html, body').animate({
				scrollTop: $("#report").offset().top - $('.header').outerHeight()
    		}, 500);
		}, 500)
		
		return false;
	});
	
	
});


function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
}

// https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}